import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { PropaneSharp } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function CustomModal(props) {
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open}
        onClose={props.handleNo}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <Box sx={{...props.style}}>
            <Typography variant="h6">
              {props.title}
            </Typography>
            <Box mt={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button color="error" onClick={props.handleNo} sx={{color: 'red'}}>{props.noLabel}</Button>
              <Button onClick={props.handleYes}>{props.yesLable}</Button>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
